// extracted by mini-css-extract-plugin
export default {"item":"menu-item-module--item--6fb93","newItem":"menu-item-module--new-item--3477b"};